module.exports = __webpack_public_path__ + "static/media/Cv1_vPA_CA_0520_pms.2a700fa5.jpg";